// Never inline on the row: an inline background outranks a `:hover` rule, killing the hover.
// Lives outside the components so Fast Refresh keeps their state, and so specs can read the
// installed sheet without knowing which sink it went into.

import { injectStyleSheet } from './injectStyleSheet';
import { ensureOverlayStyles } from './portalOverlay';

const BACKGROUND = {
    resting: 'transparent',
    hover: 'var(--malachite-card-dimmed-background, rgb(247, 247, 247))',
    selected: 'var(--malachite-accent-background-glass, rgba(0, 175, 102, 0.08))',
} as const;

const FOCUS_RING = `
  outline: 2px solid var(--malachite-text-primary, rgb(10, 10, 10));
  outline-offset: -2px;
`;

// [data-selected] and :hover tie, so source order decides.
const DROPDOWN = '.malachite-dropdown-option';

const DROPDOWN_RULES = [
    `${DROPDOWN} { background: ${BACKGROUND.resting}; }`,
    `${DROPDOWN}[data-selected='true'] { background: ${BACKGROUND.selected}; }`,
    `${DROPDOWN}:hover { background: ${BACKGROUND.hover}; }`,
    `${DROPDOWN}[data-selected='true']:hover { background: ${BACKGROUND.selected}; }`,
    `${DROPDOWN}:focus-visible {${FOCUS_RING}}`,
];

export const ensureDropdownPanelStyles = (): CSSStyleSheet | null => {
    ensureOverlayStyles();
    return injectStyleSheet('malachite-dropdown-panel-styles', DROPDOWN_RULES);
};

// The background rules all tie, so source order decides: highlight beats checked,
// disabled beats both, disabled+checked wins outright.
const MULTISELECT = '.malachite-multiselect-option';

const MULTISELECT_RULES = [
    `${MULTISELECT} { background: ${BACKGROUND.resting}; }`,
    `${MULTISELECT}[data-checked='true'] { background: ${BACKGROUND.selected}; }`,
    `${MULTISELECT}[data-highlighted='true'] { background: ${BACKGROUND.hover}; }`,
    `${MULTISELECT}[data-disabled='true'] { background: ${BACKGROUND.resting}; }`,
    `${MULTISELECT}[data-disabled='true'][data-checked='true'] { background: ${BACKGROUND.selected}; }`,
];

export const ensureMultiSelectPanelStyles = (): CSSStyleSheet | null => {
    ensureOverlayStyles();
    return injectStyleSheet('malachite-multiselect-panel-styles', MULTISELECT_RULES);
};
